import GlowyCallToAction from "components/GlowyCallToAction";

import styles from "./CareersHeader.module.css";

const CareersHeader = () => {
  return (
    <>
      <div className={styles.headerContent}>
        <h1>Help us make work frictionless</h1>
        <p>Join our growing and fully-remote team at Raycast, and empower people to supercharge their productivity.</p>
        <GlowyCallToAction href="#open-positions">See open positions</GlowyCallToAction>
      </div>
      <div className={styles.headerBg}></div>
    </>
  );
};

export default CareersHeader;
